<template>
  <div class="home">
    <Head></Head>
		<!-- 侧边栏 -->
		<aside class="aside" @mouseover="showAside()"  @mouseout="showflag=false" >
			<!--  @mouseover.stop="showAside" -->
			<div class="title" :class="{dark:!showflag}">
				replace
			</div>
			<ul class="list"  v-show="showflag">
				<li class="item" @click.stop="showSpacePanel">
					<span class="txt">
						Space
					</span>
				</li>
				<li class="item" @click.stop="showFloorPanel">
					<span class="txt">
						Floor
					</span>
				</li>
				<li class="item" @click.stop="showWallPanel">
					<span class="txt">
						Wall
					</span>
				</li>
			</ul>
		</aside>
		<!-- 空间 -->
		<div class="space" ref='space' v-show="showSpacePanelFlag">
			<ul class="navlist">
				<li class="navItem"
				 :class="{active:item.id === currentSpaceNav}"
				 @click.stop="navSpaceClick(item.id)"
				 v-for="item in spaceList"
				 :key='item.id'>{{item.cname}}</li>
			</ul>
			<div class="roomWrap">
				<div class="slider">
					<swiper :options="spaceOption">
						<swiper-slide
								v-for="slide in spaceSwiperList"
								:class="{active:slide.id === activeSpace}"
								class='slideItem'
								:key='slide.id'
								@click.native='swiperSpaceClick(slide.id)'>
							<img :src='base+slide.icon' class="pic"/>
						</swiper-slide>
					</swiper>
					<div class="control">
						<div class="prevSpace"  slot="button-prev">
							<img src="../assets/arrow_left.png" />
						</div>
						<div class="nextSpace" slot="button-next">
							<img src="../assets/arrow_right.png" />
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 地板 -->
		<div class="floor" ref='floor' v-show="showFloorPanelFlag">
			<ul class="navlist">
				<li class="navItem" 
				:class="{active:item.id === currentFloorNav}"
				v-for="item in floorList" 
				:key="item.id"
				@click="navFloorClick(item.id)">{{item.cname}}</li>
			</ul>
			<div class="box">
				
				<div class="slider">
					<swiper :options="floorOption">
						<swiper-slide 
								v-for="slide in floorSwiperList" 
								:class="{active:slide.id === activeFloor}"
								:key="slide.id"
								class='swiperItem'
								@click.native='swiperFloorClick(slide.id)'>
							<img :src='base+slide.icon' class="pic"/>
							<div class="txtWrap">
								{{slide.cname}}
							</div>
						</swiper-slide>
					</swiper>
					<div class="control">
						<div class="prevFloor"  slot="button-prev">
							<img src="../assets/arrow_left.png" />
						</div>
						<div class="nextFloor" slot="button-next">
							<img src="../assets/arrow_right.png" />
						</div>
					</div>
				</div>	
			</div>
		</div>
		
		<!-- 墙 -->
		<div class="wall"  ref='wall' v-show="showWallPanelFlag">
			<div class="box">
				<div class="slider">
					<swiper :options="wallOption">
						<swiper-slide 
								v-for="slide in wallSwiperList" 
								:class="{active:slide.id === activeWall}"
								:key="slide.id"
								@click.native='swiperWallClick(slide.id)'>
							<img :src='base+slide.pic' class="pic"/>
						</swiper-slide>
					</swiper>
					<div class="prev"  slot="button-prev">
						<img src="../assets/arrow_left.png" />
					</div>
					<div class="next" slot="button-next">
						<img src="../assets/arrow_right.png" />
					</div>
				</div>	
			</div>
			
		</div>
		<!-- filter筛选框 -->
		<div class="filter" v-show="showFilterPanelFlag">
				<div class="filterBox">
					<div class="title">FILTER</div>
					<div class="close" @click="closeFilterPanel">X</div>
					<ul class="list">
						<li class="item">
							<div class="txt">Type</div>
							<div class="selectWrap">
								<select v-model="filter.type" class="select">
									<option disabled value="">请选择</option>
									<option>A</option>
									<option>B</option>
									<option>C</option>
								</select>
								<!-- <div class="arrow">
									<img src="../assets/select.png" />
								</div> -->
							</div>
						</li>
						<li class="item">
							<div class="txt">Surface</div>
							<div class="selectWrap">
								<select v-model="filter.surface" class="select">
									<option disabled value="">请选择</option>
									<option>A</option>
									<option>B</option>
									<option>C</option>
								</select>
								<!-- <div class="arrow">
									<img src="../assets/select.png" />
								</div> -->
							</div>
						</li>
						<li class="item">
							<div class="txt">Installation Method</div>
							<div class="selectWrap">
								<select v-model="filter.method" class="select">
									<option disabled value="">请选择</option>
									<option>A</option>
									<option>B</option>
									<option>C</option>
								</select>
							</div>
						</li>
						<li class="item">
							<div class="txt">Size</div>
							<div class="selectWrap">
								<select v-model="filter.size" class="select">
									<option value="">All</option>
									<option>11,74" * 23,74</option>
									<option>11,74" * 23,74</option>
									<option>11,74" * 23,74</option>
								</select>
								<!-- <div class="arrow">
									<img src="../assets/select.png" />
								</div> -->
							</div>
						</li>
						
					</ul>
					
				</div>
			
		</div>
		<!-- 背景 -->
		<div class="home_bg" v-show="bgUrl" @click="hideAll">
			<img :src="bgUrl" class="bg" />
		</div>	
		<div class="loading" v-show="showLoadingFlag">
			<img src="../assets/loading.gif" />
		</div>
		<!-- 控制栏 -->
		<div class="bottom">
			<div class="bottomBox">
				<div class="angle">
						<div class="desc">Laying Angle:</div>
						<div class="nums">
							<span class="num" v-for="item  in  angleList" 
								:key='item.jd_id' 
								:class="{active: activeAngle === item.jd_id}"  
								@click="changeAngle(item)">{{item.name}}</span>
						</div>
				</div>
				<div class="style">
						<div class="desc">Laying Pattern:</div>
						<div class="pics">
							<div class="pic" @click="changeLayer(item)" v-for="item in layerList" >
								<img :src="base + item.icon" v-if="activeLayer  == item.pz_id"/>
								<img :src="base + item.pic" v-else />
							</div>
						</div>	 					
				</div>				
				<div class="control">
					 <ul class="list">
						<!-- <li class="item" @click="showFilterPanel">
							 <img src="../assets/icon1.png" class="icon"/>
							 <p class="txt">Filter</p>
						 </li>
						 <li class="item">
						 		<img src="../assets/icon2.png" class="icon"/>
						 		<p class="txt">Reset Filters</p>
						 </li> -->
						 <li class="item" @click="download">
						 		<img src="../assets/icon3.png" class="icon"/>
						 		<p class="txt">Download</p>
						 </li>
						 <li class="item" @click="fullscreen">
						 		<img src="../assets/icon4.png" class="icon"/>
						 		<p class="txt">Full screen</p>
						 </li>
					 </ul>
				</div>
			</div>
		</div>
  </div>
</template>

<script>
// @ is an alias to /src
import Head from '@/components/head.vue'
import Swiper from 'swiper'

export default {
  name: 'home',
	created(){
		//点击其他地方，隐藏
		this.$nextTick(function(){
			
			document.addEventListener('click',(e)=>{
					
		　　　　if(this.showSpacePanelFlag){
							if(!this.$refs.space.contains(e.target)){
									this.showSpacePanelFlag=false;
							}
		　　　　}else if(this.showFloorPanelFlag){
							if(!this.$refs.floor.contains(e.target)){
								this.showFloorPanelFlag=false;
							}	
					 }else if(this.showWallPanelFlag){
						 if(!this.$refs.wall.contains(e.target)){
							 this.showWallPanelFlag=false;
						 }
					 }	
		　　})
		
		})
	


	},
	mounted(){
		
		this.getBg();
		this.base=this.$api.base;
		console.log(this.$api.base)
	
	},
	data(){
		return{
			num:'',//退出全屏时记录当前状态使用
			selected:'',
			filter:{
				type:'',
				surface:'',
				method:'',
				size:'',
			},
			angleList:[],
			layerList:[],
			
			
			activeAngle:0,
			activeLayer:'',
			
			showflag:true, //是否显示左侧导航
			currentSpaceNav:'', //当前激活的导航(公用)
			currentFloorNav:'',
			activeSpace:'',
			activeFloor:'',
			activeWall:'',
			
			
			spaceList:[],
			spaceSwiperList:[],
			
			
			floorList:[],
			floorSwiperList:[],
			
			wallSwiperList:[],
			
			bgUrl:'', //背景图地址
			base:'', //默认地址
			
			showLoadingFlag:false,
			showSpacePanelFlag:false,
			showFloorPanelFlag:false,
			showFilterPanelFlag:false,
			showWallPanelFlag:false,	
			spaceOption: {
				slidesPerView: 3,
				spaceBetween: 20,
				slidesPerGroup: 3,
				loop: true,
				loopFillGroupWithBlank: true,
				navigation: {
					nextEl: '.nextSpace',
					prevEl: '.prevSpace'
				}
			},
			floorOption:{
				slidesPerView: 5,
				spaceBetween: 30,
				slidesPerGroup: 5,
				loop: true,
				loopFillGroupWithBlank: true,
				navigation: {
					nextEl: '.nextFloor',
					prevEl: '.prevFloor'
				}			
			},
			wallOption:{
				slidesPerView: 7,
				spaceBetween: 20,
				slidesPerGroup: 7,
				loop: true,
				loopFillGroupWithBlank: true,
				navigation: {
					nextEl: '.next',
					prevEl: '.prev'
				}	
			}
		}
	},
	methods:{
		
		changeAngle(data){ //更改角度
			this.activeAngle=data.jd_id;	
			
			this.refreshBg();
		},
		changeLayer(item){ //更改铺装方式
			this.activeLayer=item.pz_id;
			this.refreshBg();						
		},
		showAside(){
			this.showflag=true;
		},
		showSpacePanel(){  //显示场景分类
			
			// 关闭侧边栏，关闭其他面板
			this.showflag=false;
			this.showFloorPanelFlag=false;
			this.showWallPanelFlag=false;
			
			//显示当前面板
			this.showSpacePanelFlag=true;
			
			let _this=this;
			this.$api.post('Shows/getSceneclasIndex')
			.then(res =>{
				
				this.spaceList=res.data;
				
				if(this.currentSpaceNav){
					this._getSceneList(this.currentSpaceNav);
				}else{
					//获取第一个分类下的场景
					this.currentSpaceNav=res.data[0].id;	
					this._getSceneList(res.data[0].id);
				}		
			
			})
									
		},
		showFloorPanel(){
			//隐藏其他面板
			this.showflag=false;
			this.showSpacePanelFlag=false;
			this.showWallPanelFlag=false;
			
			this.showFloorPanelFlag=true;
			
			this.$api.post('Shows/getfloorclasIndex')
			.then(res =>{
				this.floorList=res.data;
				
				if(this.currentFloorNav){
					this._getFloorList(this.currentFloorNav);
				}else{ //没有数据默认选第一个
					this.currentFloorNav=res.data[0].id;				
					this._getFloorList(res.data[0].id);
				}
				
				
			})
		},
		showWallPanel(){
			this.showflag=false;
			this.showSpacePanelFlag=false;
			this.showFloorPanelFlag=false;
			
			this.showWallPanelFlag=true;
			
			let params={
				pid:5
			}
			this.$api.post('Shows/getProdclasIndex',params)
			.then(res =>{
				this.wallSwiperList=res.data;
				// this.activeWall=res.data[0].id;
			})
			
		},
		hideAll(){
			this.showflag=false;
			this.showSpacePanelFlag=false;
			this.showFloorPanelFlag=false;		
			this.showWallPanelFlag=false;						
		},
		
		// loadPic(){
		// 	let img =new Image();
		// 	this.showLoadingFlag=true;
		// 	let url=require("../assets/bg.jpg");
		// 	// let url='http://img.52z.com/upload/news/image/20180621/20180621055734_59936.jpg'
		// 	let _this=this;
		// 	img.onload=function(){
		// 		_this.bgUrl=url;
		// 		_this.showLoadingFlag=false;	
		// 	}
		// 	img.onerr=function(){
		// 		console.log('加载失败')
		// 	}
		// 	img.src=url;		
		// },
		showFilterPanel(){
			this.showFilterPanelFlag=true;
		},
		closeFilterPanel(){
			this.showFilterPanelFlag=false;
		},
		fullscreen(){ //全屏
						
			//全屏  退出全屏
			let isFullscreen=document.fullScreen||document.mozFullScreen||document.webkitIsFullScreen;
			let el=document.documentElement;
			if(!isFullscreen){//进入全屏,多重短路表达式
				(el.requestFullscreen&&el.requestFullscreen())||
				(el.mozRequestFullScreen&&el.mozRequestFullScreen())||
				(el.webkitRequestFullscreen&&el.webkitRequestFullscreen())||(el.msRequestFullscreen&&el.msRequestFullscreen());
				
				
				if(this.showSpacePanelFlag){
					this.showSpacePanelFlag=false;
					this.num=1;
				}
				if(this.showFloorPanelFlag){
					this.showFloorPanelFlag=false;
					this.num=2;
				}
				if(this.showWallPanelFlag){
					this.showWallPanelFlag=false;
					this.num=3;
				}
				
				

			}else{	//退出全屏,三目运算符
			    
				this.hideAll();
				
				if(this.num == 1){
					this.showSpacePanelFlag=true;
				}else if(this.num == 2){
					this.showFloorPanelFlag=true;
				}else if(this.num == 3){
					this.showWallPanelFlag=true;
				}
				this.num="";
				document.exitFullscreen?document.exitFullscreen():
				document.mozCancelFullScreen?document.mozCancelFullScreen():
				document.webkitExitFullscreen?document.webkitExitFullscreen():'';
			}
		},

		getBase64Images(image) {
			const canvas = document.createElement("canvas");
			canvas.width = image.width;
			canvas.height = image.height;
			const context = canvas.getContext("2d");
			context.drawImage(image, 0, 0, image.width, image.height);
			const url = canvas.toDataURL("image/png", 0);
			return url;
		},
		downloadIamge(src, name) {
			const a = document.createElement("a");
			a.download = name || "图片";
			a.style.display = "none";
			const image = new Image();
			image.src = src + "?v=" + Math.random();
			image.crossOrigin = "Anonymous";
			image.onload = () => {
				const base64 = this.getBase64Images(image);
				a.href = base64;
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
			};
		},

		download(){ //下载
			/* let url=this.bgUrl;
			let aLink=document.createElement('a');
			aLink.download="pic.png";
			aLink.href=url;
			aLink.dispatchEvent(new MouseEvent('click', {}));	 */
			this.downloadIamge(this.bgUrl)
		},
		refreshBg(){  //获取背景参数
			this.showLoadingFlag=true;
			let params={};
			if(this.activeSpace){
				params.cj_id=this.activeSpace;
			}
			if(this.activeFloor){
				params.diban_id=this.activeFloor;
			}
			if(this.activeWall){
				params.qm_id=this.activeWall;
			}
			if(this.activeLayer){
				params.pz_id=this.activeLayer;
			}
			if(this.activeAngle){
				params.jd_id=this.activeAngle;
			}	
			this.getBg(params);
		},
		getBg(params){ //获取背景
			let base=this.$api.base;
						
			this.$api.post('Shows/getShowsList',params)
			.then(res =>{
				if(res.type === 'ok'){
					// this.bgUrl=base+res.data.imgurl;
					
					//图片加载完成
					let url=base+res.data.imgurl;
					let img =new Image();
					let _this=this;					
					img.onload=function(){
						_this.showLoadingFlag=false;	
						_this.bgUrl=url;
					}
					img.onerr=function(){
						console.log('加载失败')
					}
					img.src=url;	
									
					
					this.angleList=res.data.jd_list;
					this.activeAngle=res.data.jd_id;
					this.layerList=res.data.pz_list;
					this.activeLayer=res.data.pz_id;
					
					this.activeFloor=res.data.diban_id;
					this.activeSpace=res.data.cj_id;
					this.activeWall=res.data.qm_id;
					
				}
			})	
		},
		navSpaceClick(id){ //空间nav点击
			this._getSceneList(id);
			this.currentSpaceNav=id;
		},
		navFloorClick(id){ //地板nav 点击
			this.currentFloorNav=id;
			this._getFloorList(id);
		},
		swiperSpaceClick(id){ //更改 空间
		
			this.activeSpace=id;
			this.refreshBg();
			
		},
		swiperFloorClick(id){ //地板轮播图点击
			
			this.activeFloor=id;
			this.refreshBg();			
		},
		swiperWallClick(id){ //地板轮播图点击
		
			this.activeWall=id;	
			this.refreshBg();			
		},
		_getSceneList(id){ //获取空间轮播图列表
			let params={
				clasid:id
			}
			this.$api.post('Shows/getSceneList',params)
			.then(res =>{
				if(res.type === "ok"){
					this.spaceSwiperList=res.data;
					
				}else if(res.type === 'none'){
					this.spaceSwiperList=[];
					this.activeSpace='';
				}
			})
		},
		_getFloorList(id){  //获取地板轮播图列表
			let params={
				clasid:id
			}
			this.$api.post('Shows/getfloorList',params)
			.then(res =>{
				if(res.type === "ok"){
					this.floorSwiperList=res.data;	
					
				}else if(res.type === 'none'){
					this.floorSwiperList=[];
					this.activeFloor='';
				}
				
			})
			
		},
			
	},
  components: {
		Head,
  }
}
</script>

<style lang="scss" scoped="scoped">
.home{
	position: relative;
	padding-top: 1px;
	height: 100vh;
}
.space{
	padding: 0 0  0 236px;
	display: flex;
	.navlist{	
		width: 216px;
		margin-right: 62px;
		.navItem{
			width: 216px;
			position: relative;
			height: 60px;
			line-height: 60px;
			padding-left: 16px;
			text-align: left;
			color: #fff;
			font-size: 20px;
			background-color: rgba(229,2,18,.60);
			cursor: pointer;
			&:hover{
				
			}
			&.active{
				color: #e50212;
				background-color: #fff;
				&:after{
					content: "";
					position: absolute;
					right: -60px;
					top: 0;
					border: 30px solid transparent;
					border-left-color: #fff;			
				}
			}
		}
		
	}
	.roomWrap{
		.slider{
			width:1000px;
			position: relative;
		}		
		.slideItem{
			border: 2px solid transparent;
			overflow: hidden;
			.pic{
				width: 320px;
				height: 312px;
			}
		}
		.active{
			border:2px solid #e50212;
			overflow: hidden;
		}
		.control{
			position: absolute;
			right: -220px;
			top: 120px;
			display: flex;
			.nextSpace,.prevSpace{
				width: 88px;
				height:68px;
				cursor: pointer;
			}
		}
	}
}

.filter{
	width:618px;
	height: 300px;
	border-radius: 16px;
	background-color: rgba(0,0,0,.7);
	position: fixed;
	left: 50%;
	top: 48%;
	transform: translate(-50%,-50%);
	z-index: 99;
	padding: 0 30px;
	.close{	
		font-size: 24px;
		position: absolute;
		right: 20px;
		top: 20px;
		color: #fff;
		cursor: pointer;
	}
	.title{
		font-size: 28px;
		color: #e50212;
		height: 68px;
		line-height: 68px;
	}
	.list{
		display: flex;
		flex-wrap: wrap;
		.item{
			flex: 0 0 50%;
			margin-bottom: 40px;
			.txt{
				color: #fff;
				font-size: 20px;
				line-height: 38px;
			}
		}
		.selectWrap{
			position: relative;
			margin-left: 10px;
			&:after{
				content:" ";
				display:block;
				width:24px;
				height: 44px;
				background-color: #fff;
				border-radius: 9px;		
				position: absolute;
				left: -10px;
				top: 0;
			}
			&:before{
				content:" ";
				display:block;
				width:16px;
				height: 44px;
				background-color: #fff;
				border-radius: 9px;		
				position: absolute;
				right: 30px;
				top: 0;
			}
			.arrow{
				position: absolute;
				right: 50px;
				top: 0;		
			}
		}
		
		.select{
			width: 230px;
			height: 44px;
			padding-left: 20px;
			color: #333;
			font-size: 20px;
		}
	}
}

.floor{
	padding: 0 0  0 236px;
	display: flex;
	.navlist{	
		width: 160px;
		margin-right: 62px;
		.navItem{
			position: relative;
			height: 50px;
			line-height: 50px;
			padding-left: 12px;
			text-align: left;
			color: #fff;
			font-size: 20px;
			background-color: rgba(229,2,18,.60);
			cursor: pointer;
			&:hover{
				
			}
			&.active{
				color: #e50212;
				background-color: #fff;
				&:after{
					content: "";
					position: absolute;
					right: -50px;
					top: 0;
					border: 25px solid transparent;
					border-left-color: #fff;			
				}
			}
			
		}
	}
	.box{
		.slider{
			width:1140px;
			position: relative;
			.pic{
				width: 204px;
				min-height: 204px;
			}
			.swiperItem{
				position: relative;
				
				.txtWrap{
					position: absolute;
					width: 100%;
					height: 52px;
					line-height: 52px;
					font-size: 20px;
					text-align: center;
					background-color: rgba(0,0,0,.6);
					color: #fff;
					bottom: 0;
					left: 0;
				}				
			}
		}
		.active{
			border:2px solid #e50212;
			overflow: hidden;
		}
		.control{
			position: absolute;
			right: -220px;
			top: 68px;
			display: flex;
			.nextFloor,.prevFloor{
				width: 88px;
				height:68px;
				cursor: pointer;
			}
		}
	}
	
}
.wall{
	padding: 0 0  0 390px;
	margin-top: 350px;
	.box{
		.slider{
			width:1150px;
			position: relative;
			.pic{
				width: 148px;
				cursor: pointer;	
			}
		}
		.active{
			border:2px solid #e50212;
			overflow: hidden;
		}
		.next,.prev{
			width: 88px;
			height:68px;
			cursor: pointer;
			position: absolute;
			top: 40px;
		}
		.next{
			right: -114px;
		}
		.prev{
			left:-114px;
		}
	}	
}
	
.aside{
	position: absolute;
	left: 0;
	top: 210px;
	.title{
		 width: 230px;
		 line-height: 64px;
		 height: 64px;
		 background-image: url('../assets/aside_bg.png');
		 background-repeat: no-repeat; 
		 color: #fff;
		 font-size: 24px;
		 text-transform: uppercase;
		 text-indent: 42px;
		 &.dark{
			 background-image: url('../assets/aside_bg2.png')
		 }
	 }
	 .list{
			width:194px;	
			padding: 1px 0 0 0;
			background-color: rgba(0,0,0,.52);
		 .item{
			 width: 100%;
			 height: 77px;
			 padding: 0 0 0 40px;	
			 cursor: pointer;
			 .txt{
				 width: 106px;
				 height: 77px;
				 line-height: 77px;
				 display: block;
				 color: #fff;
				 border-top: 1px solid #fff;
				 font-size: 24px;
			 }
			 &:first-child{
				 .txt{
						border-top: none;
				 }
			 }
			 &.active,&:hover{
					background-color:rgba(229,2,18,.5)
			 }		 
		 }		 
	 }
} 
.home_bg{
	position: fixed;
	left: 0;
	top: 0;
	bottom: 0;
	right:0;
	z-index: -1;
	.bg{
		width: 100%;
		height: 100%;
		// height: 100vh;
	}
}
.loading{
	position: absolute;
	width: 32px;
	height: 32px;
	left: 50%;
	top: 50%;
	transform: translate(-50%,-50%);	
}
.bottom{
	position: fixed;
	bottom: 0;
	left:0;
	width: 100%;
	height: 100px;
	background-color: rgba(0,0,0,.6);
	.bottomBox{
		width: 1630px;
		height: 100%;
		margin: 0 auto;	
		display: flex;
		align-items: center;
		justify-content: space-between;
		.angle{
			display: flex;
			align-items: center;
			.desc{
				margin-right: 24px;
			}
			.nums{
				display: flex;
			}
			.num{
				display: block;
				color: #fff;
				font-size: 20px;
				margin-right: 30px;
				cursor: pointer;
				&.active{
					color: #e50212;
				}
			}		
		}
		.style{
			display: flex;
			align-items: center;
			.desc{
				margin-right: 14px;				
			}
			.pics{
				display: flex;
				.pic{
					margin-right: 24px;
					cursor: pointer;
				}
			}			
		}
		.control{
			.list{
				display: flex;
				.item{
					width: 96px;
					margin-right: 26px;
					cursor: pointer;
					.icon{
						display: block;
						margin: 0 auto;
						margin-bottom: 6px;
					}
					.txt{
						color: #e50212;
						font-size: 16px;		
						text-align: center;
					}
				}
			}	
		}
	}
	.desc{
		color: #fff;
		font-size: 20px;		
	}
}
</style>
